<template>
  <Layout>
    <Tabs :animated="false">
      <TabPane label="Linux" icon="social-tux">

        <Row type="flex" align="top" :gutter="16" style="background:#eee;padding:20px">
          <Col :span="span" v-for="(item,idx) in items" justify="center" :key="idx">
            <AgentCard v-if="item.os=='linux'" :agent="item" :deleteItemCallback="removeItem"/>
          </Col>
        </Row>

      </TabPane>
      <TabPane label="macOS" icon="social-apple">
        <Row type="flex" align="top" :gutter="16" style="background:#eee;padding:20px">
          <Col :span="span" v-for="(item,idx) in items" justify="center" :key="idx">
            <AgentCard v-if="item.os=='darwin'" :agent="item" :deleteItemCallback="removeItem"/>
          </Col>
        </Row>
      </TabPane>
      <TabPane label="Windows" icon="social-windows">
        <Row type="flex" align="top" :gutter="16" style="background:#eee;padding:20px">
          <Col :span="span" v-for="(item,idx) in items" justify="center" :key="idx">
            <AgentCard v-if="item.os=='windows'" :agent="item" :deleteItemCallback="removeItem"/>
          </Col>
        </Row>
      </TabPane>
    </Tabs>
  </Layout>
</template>

<script>
import AgentCard from '_c/agent-card'
import { listAgents, removeAgent } from '@/api/data'

export default {
  name: 'Agent',
  components: { AgentCard },
  data () {
    return {
      span: 4.5,
      items: []
    }
  },
  mounted () {
    listAgents().then(res => {
      this.items = res.data.list
    })
  },
  methods: {
    removeItem (clientId) {
      let id = 0
      this.items = this.items.filter(function (value, index, arr) {
        if (value.client_id === clientId) {
          id = value.id
        }
        return value.client_id !== clientId
      })
      if (id > 0) {
        removeAgent(id)
      }
    }
  }
}
</script>

<style scoped>
</style>
